/* global module, require */
const THREE = require('three'),
	glass = require('../mat/glass');

module.exports = function makeGlass({
	between,
	gap,
	height,
	start,
	thickness,
	offset,
	material,
}) {
	const geo = new THREE.BoxBufferGeometry(
		between.length() - (gap || 0),
		height,
		thickness
	);

	const mesh = new THREE.Mesh(geo, material || glass);
	mesh.rotation.y = Math.PI / 2 + Math.atan2(between.x, between.z);
	mesh.position
		.copy(between)
		.divideScalar(2)
		.add(start);
	mesh.position.y += height / 2 - (offset || 0);

	return mesh;
};
